import xss from 'xss';

export const checkHTMLPresent = (str = '') => {
  if (!str) return false;
  const doc = new DOMParser().parseFromString(xss(str), 'text/html');
  return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
};

export const getQueryParamByName = (name, url) => {
  const finalUrl = !url ? window.location.href : url;
  const formattedName = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${formattedName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(finalUrl);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const getParameterByName = (name) => {
  const url = xss(window.location.href);
  const urlname = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${urlname}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  // const result = results[2].replace(/\+/g, ' '); // .replace('/', '');
  let result = '';
  if (urlname === 'navState') {
    result = results[2].replace('/', '');
  } else {
    result = results[2].replace(/\+/g, ' ');
  }
  if (urlname === 'category') {
    return checkHTMLPresent(decodeURIComponent(result))
      ? 'smartphones'
      : decodeURIComponent(result);
  }
  return decodeURIComponent(result);
};

export const getQueryParams = () => {
  const url = window.location.href;
  const queryParams = {};
  // create an anchor tag to use the property called search
  const anchor = document.createElement('a');
  // assigning url to href of anchor tag
  anchor.href = xss(url);
  // search property returns the query string of url
  const queryStrings = anchor.search.substring(1);
  if (queryStrings) {
    const params = queryStrings.split('&');

    for (let i = 0; i < params.length; i++) {
      const pair = params[i].split('=');
      queryParams[pair[0]] = decodeURIComponent(pair[1]);
    }
  }
  return queryParams;
};

export const queryStringToObj = () => {
  const search = window.location.search && window.location.search.substring(1);
  const regex = /^(true|false)/g;
  const obj = {};
  if (search) {
    search.replace(/([^=&]+)=([^&]*)/g, (m, key, value) => {
      obj[decodeURIComponent(key)] = regex.test(value)
        ? value === 'true'
        : decodeURIComponent(value);
    });
  }
  return obj;
};

export const queryStringToObjColon = () => {
  const search = window.location.search && window.location.search.substring(1);
  const regex = /^(true|false)/g;
  const obj = {};
  if (search) {
    search.replace(/([^=&]+):([^&]*)/g, (m, key, value) => {
      obj[decodeURIComponent(key)] = regex.test(value)
        ? value === 'true'
        : decodeURIComponent(value);
    });
  }
  return obj;
};

export const generateQueryString = (params, append) => {
  let query = '';
  if (Object.keys(params).length > 0) {
    query =
      (append ? '&' : '?') +
      Object.keys(params)
        .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
        .join('&');
  }
  return query;
};

export const updateQueryParamReplace = (queryParamKey, queryParamValue) => {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.set(queryParamKey, encodeURIComponent(queryParamValue));
  const newurl = `${window.location.protocol}//${window.location.host}${
    window.location.pathname
  }?${urlParams.toString()}`;
  window.history.replaceState({ path: newurl }, '', newurl);
};
